/* Oakman - Sauna Playbook CTA
 *
 * Two jobs:
 *   1. Move the single Playbook card into the article body. It sits
 *      immediately before the first <h2> that comes after at least N real
 *      paragraphs (the spot the first one-line CTA used to take), so it lands
 *      at a natural pause rather than cutting a section in half.
 *   2. Open the live Klaviyo Sauna Playbook popup on click, picking the desktop
 *      or mobile form by viewport, and report the click to GA.
 *
 * 2026-10-13: the one-line orange CTAs and the end-of-article card were
 * removed (one Playbook CTA per article, for Google). If they are ever wanted
 * back, the markup lives in git history of snippets/oak-playbook-cta.liquid.
 *
 * Fails safe. If the article body cannot be found, the card stays where Liquid
 * rendered it, below the content.
 */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 767px)';

  function articleBody() {
    return (
      document.querySelector('.blog-post-content rte-formatter') ||
      document.querySelector('.blog-post-content') ||
      document.querySelector('.article-template__content, .rte--article, [data-article-content]')
    );
  }

  /* Direct child paragraphs with enough text to count as real prose. Short
     captions and image-only paragraphs are skipped so the CTA never lands in
     the middle of a photo sequence. Our own injected CTA is excluded so
     repeated runs cannot compound. */
  function isRealParagraph(el) {
    if (el.tagName !== 'P') return false;
    if (el.hasAttribute('data-oak-cta')) return false;
    if (el.querySelector('img, iframe, video')) return false;
    return el.textContent.trim().length > 40;
  }

  function placeCard(cta, body) {
    if (!body) {
      cta.hidden = false;
      return;
    }

    /* Honour a manually pasted placeholder if an editor wants a specific spot. */
    var manual = body.querySelector('[data-oak-cta-slot]');
    if (manual && manual.parentNode) {
      manual.parentNode.replaceChild(cta, manual);
      cta.hidden = false;
      return;
    }

    /* Paragraphs that must pass before a heading qualifies. */
    var gap = parseInt(cta.getAttribute('data-min-gap'), 10);
    if (isNaN(gap) || gap < 1) gap = 5;

    /* Articles shorter than this keep the card below the content. */
    var min = parseInt(cta.getAttribute('data-min-paragraphs'), 10);
    if (isNaN(min) || min < 1) min = 4;

    var children = Array.prototype.slice.call(body.children);
    var paras = children.filter(isRealParagraph);

    if (paras.length < min) {
      cta.hidden = false;
      return;
    }

    /* How many real paragraphs remain after each index, so the card never
       sits just above the last line of the article. */
    var remaining = new Array(children.length);
    var running = 0;
    for (var r = children.length - 1; r >= 0; r--) {
      remaining[r] = running;
      if (isRealParagraph(children[r])) running++;
    }

    var since = 0;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (isRealParagraph(el)) {
        since++;
        continue;
      }
      if (el.tagName === 'H2' && since >= gap && remaining[i] >= 2) {
        el.insertAdjacentElement('beforebegin', cta);
        cta.hidden = false;
        return;
      }
    }

    /* No qualifying heading (short or heading-free article): fall back to
       "after paragraph N", never so late that nothing follows the card. */
    var after = Math.min(gap, paras.length - 1);
    paras[after - 1].insertAdjacentElement('afterend', cta);
    cta.hidden = false;
  }

  function openForm(cta) {
    var isMobile = window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;
    var id = isMobile
      ? cta.getAttribute('data-form-mobile')
      : cta.getAttribute('data-form-desktop');
    var fallback = cta.getAttribute('data-fallback-url');

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'playbook_cta_click', {
        cta_variant: cta.getAttribute('data-variant') || 'card',
        cta_position: cta.getAttribute('data-position') || 'primary'
      });
    }

    /* klaviyo.js is loaded async in theme.liquid. If it has not arrived, send
       the reader somewhere useful instead of doing nothing. */
    if (!window.klaviyo && !window._klOnsite) {
      if (fallback) window.location.href = fallback;
      return;
    }

    if (!id) {
      if (fallback) window.location.href = fallback;
      return;
    }

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', id]);
  }

  function wire(cta) {
    var btn = cta.querySelector('[data-oak-cta-open]');
    if (!btn || btn.hasAttribute('data-oak-wired')) return;
    btn.setAttribute('data-oak-wired', '');
    btn.addEventListener('click', function () {
      openForm(cta);
    });
  }

  function init() {
    var body = articleBody();

    var card = document.querySelector('[data-oak-cta][data-variant="inline"]');
    if (card) placeCard(card, body);

    Array.prototype.forEach.call(document.querySelectorAll('[data-oak-cta]'), function (cta) {
      if (cta.parentNode) wire(cta);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
